import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
    errorBanner: {
        marginTop: theme.spacing(4),
        border: `1px solid ${theme.palette.error.main}`,
    },
}));
